module.exports = __webpack_public_path__ + "static/media/home-loan.38506adf8b6c5f5db16d7548b6787335.png";